export default __webpack_public_path__ + "assets/canopy_l.png";